import React from "react";
import { Alert, AlertTitle, Button, Box, Typography } from "@mui/material";
import { Cookie as CookieIcon, Link as LinkIcon } from "@mui/icons-material";

const CookieWarningBanner = ({ cookiesExpired }) => {
  const handleExtensionClick = () => {
    window.open(
      "https://chromewebstore.google.com/detail/upstart13-candidate-sourc/cbeojheckkpfadlgbemgdldiafjogdbi?utm_source=item-share-cb&pli=1",
      "_blank"
    );
  };

  if (!cookiesExpired) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      icon={<CookieIcon />}
      sx={{
        mb: 3,
        "& .MuiAlert-message": {
          width: "100%",
        },
      }}
      action={
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<LinkIcon />}
          onClick={handleExtensionClick}
          sx={{ ml: 2 }}
        >
          Get Extension
        </Button>
      }
    >
      <AlertTitle>Cookies Expired</AlertTitle>
      <Typography variant="body2">
        Your LinkedIn cookies have expired. Please add your cookies to sync with
        the server and continue using the application.
      </Typography>
    </Alert>
  );
};

export default CookieWarningBanner;
